import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';
import * as decode from 'jwt-decode';

@Injectable()
export class RoleGuard implements CanActivate {

  constructor(public auth: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      const allowed_roles = next.data.allowed_roles;
      const token = localStorage.getItem('token');

      var role = "";
      if(token){
        const tokenBody = decode(token);
        role = tokenBody.role;
      } else {
        this.router.navigate(['/login']);
        return false;
      }


      if(token && this.auth.isAuthenticated() && allowed_roles.indexOf(role) !== -1) {
        return true;
      }

      this.router.navigate(['/error/403']);
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth/role.guard.ts